import React, { type HTMLProps, useState, useEffect, useRef } from "react";

interface ImageProps extends HTMLProps<HTMLImageElement> {
  onFallback?: () => void;
  onSuccess?: () => void;
  fallbackSrc?: string;
  fallbackSrcSet?: string;
  fallbackClassName?: string;
}

export function ImageWithFallback({ onSuccess, onFallback, fallbackSrc, fallbackSrcSet, fallbackClassName, ...rest }: ImageProps) {
  const imgRef = useRef<HTMLImageElement>(null);
  const [src, setSrc] = useState(rest.src);
  const [srcSet, setSrcSet] = useState(rest.srcSet);
  const [className, setClassName] = useState(rest.className);

  useEffect(() => {
    const img = imgRef.current;

    if (img?.complete) {
      onSuccess?.();
    }
  }, [onSuccess]);

  return (
    <img
      ref={imgRef}
      {...rest}
      className={className}
      src={src}
      srcSet={srcSet}
      onLoad={e => {
        rest.onLoad?.(e);

        if (src && src !== fallbackSrc) {
          onSuccess?.();
        }

        if (srcSet && srcSet !== fallbackSrcSet) {
          onSuccess?.();
        }
      }}
      onError={err => {
        rest.onError?.(err);
        setSrc(fallbackSrc);
        setSrcSet(fallbackSrcSet);
        if (typeof fallbackClassName === "string") {
          setClassName(fallbackClassName);
        }
        onFallback?.();
      }}
      alt={rest.alt}
    />
  );
}
